module.exports = __webpack_public_path__ + "img/13f-doc-emissao-confirmar.2545985b.png";